import { api } from "@/lib/api";
import { toast } from "sonner";

export async function downloadBlob(path, filename) {
  try {
    const res = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
    toast.success("Download started");
  } catch {
    toast.error("You do not have access or the file is unavailable.");
  }
}
